import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { SimulationType } from '@app/dao/simulation/simulation.interface';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { Subject } from 'rxjs';
import { EaSimulationSoficaFormBuilder } from './ea-simulation-sofica-form.builder';

@Component({
    selector: 'ea-simulation-sofica-form',
    templateUrl: './ea-simulation-sofica-form.component.html',
    styleUrls: ['./ea-simulation-sofica-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationSoficaFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationSoficaFormComponent
  extends EaSimulationSoficaFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();
  defiscalisations: any[] = [
    {
      id: 30,
      name: '30%',
    },
    {
      id: 36,
      name: '36%',
    },
    {
      id: 48,
      name: '48%',
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {}

  onSubmit() {
    this.prFormService.loading();
    this.simulationDao
      .simulate(null, SimulationType.SOFICA, this.extract())
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (this.callback) this.callback(success);
          this.notificationService.success('La simulation a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La simulation a échoué');
        },
      );
  }
}
